/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

import { Vocabulary } from "../../../Utils/Vocabulary";
import CustomPanel from "../../CustomPanel";
import styles from "../../../Styles/clientHistory.module.css";
import { useEffect, useState } from "react";
import { endpoints, localUrlEnum } from "../../../Utils/UrlEnum";
import { ClientHistoryProps } from "../../../Utils/Types";
import { AxiosResponse } from "axios";
import { getData } from "../../../Services/getData";
import {
  OrderModel,
  OrderTypeModel,
  OrderValidationSchema,
  ProductsModel,
} from "../../../Utils/Models";
import { Autocomplete, Grid, InputAdornment, TextField } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { onFormError, OrderStatusType } from "../../../Utils/Utils";
import { EditProduct } from "../EditProduct";
import useCustomMemo from "../../../Hooks/useCustomMemo";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormsIds } from "../../../Utils/Constants";
import { postData } from "../../../Services/postData";

export default function ClientHistory(props: ClientHistoryProps) {
  const { getCurrentValues, products } = props;
  const [previousOrders, setPreviousOrders] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState<ProductsModel[]>();
  const memo = useCustomMemo();
  const orderTypes = memo?.storage?.orderTypes;
  const client = getCurrentValues("client_id");
  const parsedRecommendation = {
    ...getCurrentValues("recommendation_id"),
    user_id: getCurrentValues("recommendation_id.user_id._id"),
  };
  const { control, getValues, setValue, clearErrors, trigger, handleSubmit } =
    useForm({
      resolver: yupResolver(OrderValidationSchema),
      mode: "onChange",
      reValidateMode: "onChange",
      context: undefined,
      shouldFocusError: true,
      shouldUnregister: false,
      criteriaMode: "firstError",
      defaultValues: {
        ...getCurrentValues(),
        client_id: client,
        product: null,
        instructor_id: getCurrentValues("instructor_id._id"),
        recommendation_id: parsedRecommendation,
        classId: null,
        ARRNumber: null,
        source: "manual",
      },
    });

  useEffect(() => {
    getPreviousOrders();
  }, []);

  const getPreviousOrders = async () => {
    if (client?._id)
      getData(`${endpoints.clientsOrderHistory}/${client?._id}`).then(
        (res: AxiosResponse) => {
          if (!res?.data) return;
          setPreviousOrders(res.data);
        },
      );
  };

  /**
   *
   * @param e
   * @param product
   * @param reason
   * @param details
   */
  const handleProductChange = (
    e: any,
    product: any,
    reason: any,
    details: any,
  ) => {
    // Transform documentTypes from objects to string IDs
    const transformedProduct = {
      ...details.option,
      documentTypes:
        details.option?.documentTypes?.map((dt: any) =>
          typeof dt === "string" ? dt : dt._id,
        ) || [],
    };

    setValue(`product`, transformedProduct);

    // set the correct price based on the client's workpoint
    const clientWorkPoint = getValues("client_id.workPointId._id");
    const producPrice = getValues("product.prices").find(
      (price: any) =>
        price.workPointId._id === clientWorkPoint ||
        price.workPointId === clientWorkPoint,
    );
    setValue("product.price", producPrice?.price);
    if (clearErrors) clearErrors("product");
    trigger("product");
  };

  const renderOrderDetails = (order: OrderModel) => {
    const handleOrderClick = () => {
      if (order?._id) {
        window.open(`${localUrlEnum.order}/${order._id}`, "_blank");
      }
    };

    return (
      <div
        key={order._id}
        className={styles.orderItem}
        onClick={handleOrderClick}
        style={{ cursor: "pointer" }}
      >
        <div className={styles.orderHeading}>
          <div>{Vocabulary.id}:</div>
          <div>{Vocabulary.name}:</div>
          <div>{Vocabulary.phone}:</div>
          <div>{Vocabulary.email}:</div>
          <div>{Vocabulary.product}:</div>
        </div>
        <div className={styles.orderHeading}>
          <div>{order?.orderNumber}</div>
          <div>
            {order?.client_id?.firstName + " " + order?.client_id?.lastName}
          </div>
          <div>{order?.client_id?.phone}</div>
          <div>{order?.client_id?.email}</div>
          <strong>{order?.product?.name}</strong>
        </div>
      </div>
    );
  };

  const onSubmit = (data: any) => {
    const currentClientId = getValues("client_id");
    const currentInstructorId = getValues("instructor_id");
    data.client_id = currentClientId;
    data.instructor_id = currentInstructorId;
    data.source = "manual";

    postData(endpoints.ordersEndpoint, data)
      .then((res: AxiosResponse) => {
        if (res?.data && res.data._id) {
          window.location.href = `${localUrlEnum.order}/${res.data._id}`;
          setValue("_id", res.data._id);
          setValue("status", res.data.status);
        } else {
          console.error(res?.data);
        }
      })
      .catch((error) => {
        console.error("Error during API request:", error);
      });
  };
  /**
   *
   */
  return (
    <div className={styles.mainContainer}>
      <CustomPanel
        style={{ backgroundColor: "#8080801a !important" }}
        title={Vocabulary.clientHistory}
      >
        {" "}
        {previousOrders.map((order: OrderModel) => renderOrderDetails(order))}
      </CustomPanel>
      <CustomPanel
        style={{ backgroundColor: "#8080801a !important" }}
        title={Vocabulary.addNewProductToClient}
      >
        <form
          id={FormsIds.addNewProductToClient}
          onSubmit={handleSubmit(onSubmit, onFormError)}
          style={{ padding: "2rem" }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={12}>
              <Controller
                name="orderType"
                control={control}
                render={({
                  field: { ref, ...field },
                  fieldState: { error },
                }) => (
                  <Autocomplete
                    value={field?.value ?? null}
                    disablePortal
                    disableClearable
                    clearOnBlur={true}
                    options={orderTypes ?? []}
                    getOptionLabel={(option: OrderTypeModel) =>
                      option?.name || ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option?.name === value?.name
                    }
                    onChange={(event, value) => {
                      field.onChange(value); // Update field value
                      const orderType =
                        value?.name === OrderStatusType?.Certification;
                      const correctProducts = products?.filter(
                        (product: ProductsModel): product is ProductsModel =>
                          product?.isCertificate === orderType,
                      );
                      setFilteredProducts(correctProducts);
                      setValue("product.price", null);
                      setValue("product.name", null);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        value={field?.value || " "}
                        label={Vocabulary.selectProduct}
                        error={!!error}
                        helperText={error?.message}
                        variant="standard"
                      />
                    )}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <EditProduct
                control={control}
                getValues={getValues}
                onProductChange={(e, product, reason, details) => {
                  handleProductChange(e, product, reason, details);
                }}
                products={filteredProducts}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Controller
                name="product.price"
                control={control}
                render={({
                  field: { ref, ...field },
                  fieldState: { error },
                }) => (
                  <TextField
                    {...field}
                    value={field?.value || ""}
                    type="number"
                    label={Vocabulary.pret}
                    id="product.price"
                    required
                    fullWidth
                    variant="standard"
                    error={!!error}
                    helperText={error?.message}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {Vocabulary.currency}
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </form>
      </CustomPanel>
    </div>
  );
}
